import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import {Accordion,AccordionSummary,AccordionDetails, Grid, Button, CircularProgress, Tooltip } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CkEditorText, PageLoader } from '../../../shared_elements';
import EditIcon from '@material-ui/icons/Edit';
import { checkApiStatus ,onCheckFormPermission} from '../../../utils_v2';
import { globalPutService } from '../../../utils_v2/globalApiServices';
const ContentExpansion = ({params, title, valueKey, content, prsDetail, updateIntroduction,currentFormDetail,getCurrentFormDetail}) => {
    const [htmlContent, setHtmlContent] = useState(content)
    const [editMode, setEditMode] = useState(false);
    const [isExpand, setExpand] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const onUpdatePrsInfo = (key, value, required) => {
        setLoading(true)
        globalPutService(`technical/workorder/${params.workOrderSlug}/gap-report/${params.id}/?asset_type=${params.type}`, {gap_report_section:prsDetail?.gap_report_section?.id, [valueKey]:htmlContent})
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}})
                setEditMode(false);
                getCurrentFormDetail()
                setLoading(false)
            }else{
                enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}})
            }
        });
    }
    return(
        <div>
            <Accordion square expanded={isExpand} onChange={(e,expanded)=> setExpand(expanded)}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" >
                    {title}
                    {  onCheckFormPermission(currentFormDetail) ? !editMode ?
                        <Tooltip title='Edit' arrow><EditIcon onClick={(e)=> {e.preventDefault();e.stopPropagation();setEditMode(true);setExpand(true)}} style={{marginLeft:'auto', cursor:'pointer'}} color='primary' fontSize='small' /></Tooltip>:null
                    : null }
                </AccordionSummary>
                <AccordionDetails style={{background:'#f9f7f7'}}>
                    <Grid container spacing={1}>
                        <Grid item md={12}>
                            { editMode ? 
                                <CkEditorText
                                    htmlData={htmlContent}
                                    onChangeData={(data) => setHtmlContent(data)}
                                />:
                                htmlContent ? <div className='comment-content' dangerouslySetInnerHTML={{__html: htmlContent}}></div>:'--'
                            }
                        </Grid>
                        { editMode ?
                            <Grid item md={12}>
                                <ul className='list-inline'>
                                    <li className='list-inline-item'>
                                        <Button disabled={ isLoading } onClick={() => {setEditMode(false); setHtmlContent(content)}} color='primary' variant='outlined' size='small'>Cancel</Button>
                                    </li>
                                    <li className='list-inline-item'>
                                        <Button onClick={onUpdatePrsInfo} disabled={ !htmlContent.length || isLoading } color='primary' variant='contained' size='small'>{isLoading ? <CircularProgress size={24} /> : 'Submit'}</Button>
                                    </li>
                                </ul>
                            </Grid>:null
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>
            {isLoading ? <PageLoader/> : null}
        </div>
    )
}
export default withRouter(ContentExpansion);